<template>
  <div class="pic-text-card">
    <div class="pic-text-consult">
      <div class="header">
        <img :src="picIcon" class="picIcon" />
        <text class="title">{{ msg.titleToDoctorAssistant }}</text>
      </div>
      <div class="body">
        <div class="label">就诊人</div>
        <div class="name">{{ msg.patientName }}</div>
        <div>
          {{
            `${msg.patientGender || ''}${msg.patientGender ? '·' : ''}${
              msg.patientAge || msg.patientAge === 0 ? `${msg.patientAge}岁` : ''
            }`
          }}
        </div>
      </div>
      <div class="body">
        <div class="label">咨询时间</div>
        <div>
          {{
            msg.realStartTime && msg.realStartTime !== 'null' ? msg.realStartTime : msg.confirmTime
          }}
        </div>
      </div>
      <div @click="handleClick" class="card-footer">查看详情</div>
    </div>
    <ConsultCardInfo ref="consultCardInfoRef" :info="msg"></ConsultCardInfo>
  </div>
</template>

<script setup>
import { defineProps, ref } from 'vue'
import picIcon from '@/assets/img/video.png'
import ConsultCardInfo from './ConsultCard/consultCardInfo.vue'
const consultCardInfoRef = ref(null)

const props = defineProps({
  msg: {
    type: Object,
    default: () => ({})
  }
})
const handleClick = () => {
  consultCardInfoRef.value.initData()
}
</script>

<style scoped lang="scss">
.pic-text-card {
  display: flex;
  justify-content: center;
  .pic-text-consult {
    background-image: linear-gradient(180deg, #e2eefb 0%, #ffffff 36%);
    border-radius: 13px;
    width: 408px;
    padding: 12px 16px 14px 16px;
    .header {
      display: flex;
      align-items: center;
      padding-bottom: 12px;
      .picIcon {
        width: 24px;
        height: 24px;
        margin-right: 8px;
      }
      .title {
        font-weight: 500;
        font-size: 16px;
        color: #1b1b1b;
      }
    }

    .body {
      display: flex;
      align-items: center;
      padding-bottom: 14px;
      font-weight: 400;
      font-size: 16px;
      color: #333;
      .label {
        color: #999;
        margin-right: 16px;
      }
      .name {
        max-width: 40%;
        margin-right: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .tag {
        min-width: 12%;
        padding: 4px 8px;
        margin-left: 10px;
        border-radius: 8px;
        background: #f3f7ff;
        font-weight: 400;
        font-size: 14px;
        color: #7e8698;
      }
    }
  }
  .card-footer {
    border-top: 1px solid #fafafa;
    padding-top: 12px;
    font-size: 16px;
    color: #3f64ff;
    text-align: center;
    cursor: pointer;
  }
}
</style>
